/* tslint:disable */
/* eslint-disable */
/**
 * Pricing API
 * API for managing pricing.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BorrowerContractFunnelV2Dto } from './BorrowerContractFunnelV2Dto';
import {
    BorrowerContractFunnelV2DtoFromJSON,
    BorrowerContractFunnelV2DtoFromJSONTyped,
    BorrowerContractFunnelV2DtoToJSON,
    BorrowerContractFunnelV2DtoToJSONTyped,
} from './BorrowerContractFunnelV2Dto';
import type { SidebarComponentDto } from './SidebarComponentDto';
import {
    SidebarComponentDtoFromJSON,
    SidebarComponentDtoFromJSONTyped,
    SidebarComponentDtoToJSON,
    SidebarComponentDtoToJSONTyped,
} from './SidebarComponentDto';
import type { BorrowerPricingHeaderInfoDto } from './BorrowerPricingHeaderInfoDto';
import {
    BorrowerPricingHeaderInfoDtoFromJSON,
    BorrowerPricingHeaderInfoDtoFromJSONTyped,
    BorrowerPricingHeaderInfoDtoToJSON,
    BorrowerPricingHeaderInfoDtoToJSONTyped,
} from './BorrowerPricingHeaderInfoDto';
import type { GuaranteeFilterDto } from './GuaranteeFilterDto';
import {
    GuaranteeFilterDtoFromJSON,
    GuaranteeFilterDtoFromJSONTyped,
    GuaranteeFilterDtoToJSON,
    GuaranteeFilterDtoToJSONTyped,
} from './GuaranteeFilterDto';

/**
 * Response for borrower comparateur v2 with async pricing via SignalR
 * @export
 * @interface BorrowerComparateurV2Response
 */
export interface BorrowerComparateurV2Response {
    /**
     * 
     * @type {BorrowerPricingHeaderInfoDto}
     * @memberof BorrowerComparateurV2Response
     */
    headerInfo?: BorrowerPricingHeaderInfoDto;
    /**
     * 
     * @type {Array<BorrowerContractFunnelV2Dto>}
     * @memberof BorrowerComparateurV2Response
     */
    contractFunnels: Array<BorrowerContractFunnelV2Dto>;
    /**
     * Available guarantees filters
     * @type {Array<GuaranteeFilterDto>}
     * @memberof BorrowerComparateurV2Response
     */
    guarantees?: Array<GuaranteeFilterDto> | null;
    /**
     * Sidebar components (PRICING_FILTERS, PRICING_VARIABLE_AND_FEES)
     * @type {Array<SidebarComponentDto>}
     * @memberof BorrowerComparateurV2Response
     */
    sidebar?: Array<SidebarComponentDto> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof BorrowerComparateurV2Response
     */
    warningMessages?: Array<string> | null;
}

/**
 * Check if a given object implements the BorrowerComparateurV2Response interface.
 */
export function instanceOfBorrowerComparateurV2Response(value: object): value is BorrowerComparateurV2Response {
    if (!('contractFunnels' in value) || value['contractFunnels'] === undefined) return false;
    return true;
}

export function BorrowerComparateurV2ResponseFromJSON(json: any): BorrowerComparateurV2Response {
    return BorrowerComparateurV2ResponseFromJSONTyped(json, false);
}

export function BorrowerComparateurV2ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorrowerComparateurV2Response {
    if (json == null) {
        return json;
    }
    return {
        
        'headerInfo': json['headerInfo'] == null ? undefined : BorrowerPricingHeaderInfoDtoFromJSON(json['headerInfo']),
        'contractFunnels': ((json['contractFunnels'] as Array<any>).map(BorrowerContractFunnelV2DtoFromJSON)),
        'guarantees': json['guarantees'] == null ? undefined : ((json['guarantees'] as Array<any>).map(GuaranteeFilterDtoFromJSON)),
        'sidebar': json['sidebar'] == null ? undefined : ((json['sidebar'] as Array<any>).map(SidebarComponentDtoFromJSON)),
        'warningMessages': json['warningMessages'] == null ? undefined : json['warningMessages'],
    };
}

export function BorrowerComparateurV2ResponseToJSON(json: any): BorrowerComparateurV2Response {
    return BorrowerComparateurV2ResponseToJSONTyped(json, false);
}

export function BorrowerComparateurV2ResponseToJSONTyped(value?: BorrowerComparateurV2Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'headerInfo': BorrowerPricingHeaderInfoDtoToJSON(value['headerInfo']),
        'contractFunnels': ((value['contractFunnels'] as Array<any>).map(BorrowerContractFunnelV2DtoToJSON)),
        'guarantees': value['guarantees'] == null ? undefined : ((value['guarantees'] as Array<any>).map(GuaranteeFilterDtoToJSON)),
        'sidebar': value['sidebar'] == null ? undefined : ((value['sidebar'] as Array<any>).map(SidebarComponentDtoToJSON)),
        'warningMessages': value['warningMessages'],
    };
}

